import { DragonBonesBaseController, IDragonBonesControllerConfiguration, Inject } from "@denishussar/html5-game-engine";

export class PlayerFrontController extends DragonBonesBaseController {
    $model: any;

    public constructor(@Inject private _options) {
        super("PlayerFrontController");
    }

    public getConfiguration(): IDragonBonesControllerConfiguration {
        return {
            armatureName: this._options.name,
            childControllers: {},
            animations: {
                idle: "idle",
                sad: "sad",
                happy: "happy",
            },
            queue: {
                idle: {
                    condition: (clock) => clock > 3.13,
                    action: () => {
                        this._idle();
                    }
                }
            }
        };
    }

    public onInitialize(): void {
        this.scaleX = 0.90;
        this.scaleY = 0.90;
    }


    private _idle() {
        this.$animations.get("idle").play(-1);
    };

    win() {
        this.$animations.get("happy").play(1);
        this.$queue.get("idle").addToQueue(60, {});
    }

    lose() {
        this.$animations.get("sad").play(-1);
    }

    tie() {
        this._idle();
    }
}